import { render, staticRenderFns } from "./SingleAddToBasket.vue?vue&type=template&id=22f724e0&"
import script from "./SingleAddToBasket.vue?vue&type=script&lang=js&"
export * from "./SingleAddToBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f724e0')) {
      api.createRecord('22f724e0', component.options)
    } else {
      api.reload('22f724e0', component.options)
    }
    module.hot.accept("./SingleAddToBasket.vue?vue&type=template&id=22f724e0&", function () {
      api.rerender('22f724e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleAddToBasket.vue"
export default component.exports